import { BASE_URL } from "../api/providerApi";

// Load reCAPTCHA v3 script dynamically
export const loadRecaptcha = () => {
    return new Promise((resolve, reject) => {
        if (window.grecaptcha) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
        script.async = true;
        script.defer = true;

        script.onload = () => resolve();
        script.onerror = () => reject('Failed to load reCAPTCHA');

        document.body.appendChild(script);
    });
};

// Get a reCAPTCHA token (v3)
export const getCaptchaToken = () => {
    return new Promise((resolve, reject) => {
        if (!window.grecaptcha) {
            reject('reCAPTCHA not loaded');
            return;
        }

        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: 'getToken' })
                .then(resolve)
                .catch(reject);
        });
    });
};

// Call your getToken API with reCAPTCHA token
export const getTokenAPI = async () => {
    try {
        // 1️⃣ Load reCAPTCHA script
        await loadRecaptcha();

        // 2️⃣ Generate token
        const recaptchaToken = await getCaptchaToken();
        // 3️⃣ Call API using fetch
        const response = await fetch(`${BASE_URL}/providerempanelment/getToken`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                accept: '*/*',
            },
            body: JSON.stringify({
                clientId: process.env.REACT_APP_CLIENT_ID,
                clientSecret: process.env.REACT_APP_CLIENT_SECRET,
                echoToken: recaptchaToken,
            }),
        });

        if (!response.ok) {
            throw new Error('Failed to get API token');
        }

        const result = await response.json();
        return result;
    } catch (err) {
        console.error('Error in getTokenAPI:', err);
        throw err;
    }
};



export const toAmPm = (time24) => {
    if (!time24) return '';
    let [hours, minutes] = time24.split(':').map(Number);

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;

    return `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
};

export const to24Hour = (time, ampm) => {
    let [hours, minutes] = time.split(':').map(Number);
    if (ampm === 'PM' && hours !== 12) hours += 12;
    if (ampm === 'AM' && hours === 12) hours = 0;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

